<template>
  <b-card no-body style="border: none">
    <b-card-header
      class="text-center p-3 bg-primary hiddenItem"
      style="display: flex; justify-content: space-between"
    >
      <h2 class="text-white">{{ $t("testResult") }}</h2>
      <b-button-group>
        <b-button variant="outline-light" @click="print('printme')">
          <i class="fa fa-print"></i>
          {{ $t("actions.print") }}
        </b-button>
        <b-button variant="outline-light" @click="$emit('cancel')">
          <i style="font-size: 20px" class="fa fa-times"></i>
        </b-button>
      </b-button-group>
    </b-card-header>
    <div v-if="isLoader" class="text-center hiddenItem">
      <b-spinner label="Loading..."></b-spinner>
    </div>

    <div v-if="!isLoader" ref="document" id="printme">
      <div class="d-flex pl-4 pr-4 pt-4 pb-0">
        <div class="mt-1">
          <h5 class="mb-3">
            {{ $t("EmployeeFIO") }}:
            <strong v-if="candidateData">
              {{ candidateData.lastName }}
              {{ candidateData.firstName }}

              {{ candidateData.parentName }}
            </strong>
          </h5>
          <h5 class="mb-3">
            {{ $t("allTest") }}:
            <strong>30</strong>
          </h5>
          <h5 class="mb-3">
            {{ $t("allTestCorrect") }}:
            <strong v-if="testEmployee">{{ testEmployee.corrects }}</strong>
          </h5>
          <h5 class="mb-3">
            {{ $t("allTestNoCorrect") }}:
            <strong>{{ noCorrect }}</strong>
          </h5>
        </div>
        <div class="text-center ml-5 pl-5" v-if="testEmployee">
          <radial-progress-bar
            :strokeWidth="20"
            :innerStrokeWidth="20"
            :diameter="200"
            :completed-steps="testEmployee.corrects"
            :total-steps="30"
            startColor="#007BFF"
            stopColor="#007BFF"
          >
            <h2>{{ testEmployee.correctsInProportion + "%" }}</h2>
          </radial-progress-bar>
          <h5 class="m-0">{{ 30 + "/" + testEmployee.corrects }}</h5>
        </div>
      </div>

      <b-card-body>
        <div
          v-for="(item, index) in questionsDto"
          :key="index"
          class="con pl-3 pr-3"
        >
          <h5 class="mb-4 mt-2">
            {{ index + 1 }}.
            {{
              item[$localeKey()]
            }}
          </h5>
          <b-form-radio-group size="lg" v-model="isTrue">
            <b-form-radio
              :disabled="!choice.isAnswer"
              style="display: block"
              v-for="(choice, i) in item.answers"
              :key="i"
              :value="choice.isSelect"
            >
              <p style="line-height: 25px">
                {{
                  choice[$localeKey()]
                }}
                <i
                  v-if="choice.isSelect === true && choice.isAnswer === true"
                  style="color: #038a04; font-size: 25px; margin-top: 5px"
                  class="fa fa-check"
                  aria-hidden="true"
                ></i>
                <i
                  v-if="choice.isSelect === true && choice.isAnswer === false"
                  style="color: #dd0f16; font-size: 25px"
                  class="fa fa-times"
                  aria-hidden="true"
                ></i>
              </p>
            </b-form-radio>
          </b-form-radio-group>
        </div>
      </b-card-body>
    </div>
  </b-card>
</template>
<script>
import { mapState } from "vuex";
import vacancyService from "@/services/vacancy.service";
import RadialProgressBar from "vue-radial-progress";

export default {
  components: {
    RadialProgressBar,
  },
  props: ["status"],
  data() {
    return {
      noCorrect: null,
      isLoader: false,
      isShow: true,
      isTrue: true,
      questionsDto: null,
      testEmployee: null,
    };
  },
  methods: {
    print(divName) {
      var printContents = document.getElementById(divName).innerHTML;
      var originalContents = document.body.innerHTML;

      document.body.innerHTML = printContents;

      window.print();

      document.body.innerHTML = originalContents;
    },
    // print() {
    //   window.print();
    // },
    async getResult(id, vId) {
      try {
        this.isLoader = true;
        let res = await vacancyService.getTestResult(id, vId);
        await this.setResult(res.data ? res.data : null);
        this.isLoader = false;
      } catch (e) {
        await this.setResult(null);
      }
    },
    setResult(data) {
      this.$nextTick(() => {
        this.questionsDto = data.questionsDto;
        this.testEmployee = data.testEmployee;
        this.noCorrect = 30 - this.testEmployee.corrects;
      });
    },
  },
  computed: {
    ...mapState("employee", ["employee", "candidateData", "modalClose"]),
  },
};
</script>
<style>
@media print {
  .hiddenItem {
    display: none !important;
  }
}
.con {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  -o-user-select: none;
  user-select: none;
}
</style>
